/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Provisioning_Partner_Code_UnavailableInputs */

const es_co2_error_provisioning_partner_code_unavailable = /** @type {(inputs: Error_Provisioning_Partner_Code_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese destino no está disponible.`)
};

/**

* @param {Error_Provisioning_Partner_Code_UnavailableInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_provisioning_partner_code_unavailable = /** @type {((inputs?: Error_Provisioning_Partner_Code_UnavailableInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Provisioning_Partner_Code_UnavailableInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_provisioning_partner_code_unavailable(inputs)
});